import { Text } from '@mantine/core';
import { SecurityPillStyles } from '@dealstack/frontend/shared/components/SecurityPill/SecurityPill.styles.tsx';

interface Props {
	label: string;
	borderColor?: string;
	color?: string;
	'data-testid'?: string;
}

export const SecurityPill = ({ label, borderColor, color, 'data-testid': dataTestId }: Props) => {
	return (
		<SecurityPillStyles>
			{/* v7's Box spreads style props (`c`) after the `style` prop, so a static
			    `c` would clobber the feature `color` (e.g. orange Residue text fell
			    back to grey). Carry the text colour through `c` and keep only
			    `borderColor` inline. */}
			<Text
				c={color ?? 'dark.4'}
				fz="sm"
				className="pill"
				style={{ borderColor }}
				data-testid={dataTestId}
			>
				{label}
			</Text>
		</SecurityPillStyles>
	);
};
